import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { sampleChanged, inputSampleSelector } from 'redux/schemaSlice';
import useSchemaRequest from 'hooks/useSchemaRequest';
import useWizardNavigation from 'hooks/useWizardNavigation';

import NavigationButtons from 'components/NavigationButtons';

import { StyledTextField } from './ProvideSampleDataStep-styled';

const ProvideSampleDataStep: React.FC = () => {
  const dispatch = useDispatch();
  const inputSample = useSelector(inputSampleSelector);
  const { requestSchema, isLoading } = useSchemaRequest();
  const { next } = useWizardNavigation();

  const onNext = async () => {
    try {
      await requestSchema();
      next();
    } catch {}
  };

  return (
    <>
      <StyledTextField
        disabled={isLoading}
        placeholder="Provide sample data"
        resize="vertical"
        rows={15}
        value={inputSample}
        onChange={value => dispatch(sampleChanged(value))}
      />
      <NavigationButtons
        onNext={onNext}
        nextIsDisabled={!inputSample}
        nextIsLoading={isLoading}
      ></NavigationButtons>
    </>
  );
};

export default ProvideSampleDataStep;
